import { render } from "./ServiceTicketList.vue?vue&type=template&id=0214cbe0"
import script from "./ServiceTicketList.vue?vue&type=script&lang=js"
export * from "./ServiceTicketList.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0214cbe0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0214cbe0', script)) {
    api.reload('0214cbe0', script)
  }
  
  module.hot.accept("./ServiceTicketList.vue?vue&type=template&id=0214cbe0", () => {
    api.rerender('0214cbe0', render)
  })

}

script.__file = "src/views/services/modules/ServiceTicketList.vue"

export default script